import React, { FC, useEffect } from 'react';
import { SCUICollapsiblePaper } from '../../../../../atomic/molecules';
import { BillingCommand } from '../../../../../services/command';
import { Grid, Fade, LinearProgress } from '@mui/material';
import Swal from 'sweetalert2';

import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import './SCUIBillingServiceDrawerContent.scss';

export const SCUIBillingServiceDrawerContent: FC<{
    id?: number;
    onClose?: any;
}> = ({ id, onClose }) => {
    const [loading, setLoading] = React.useState(true);
    const [billingLog, setBillingLog] = React.useState<any>();
    const { t } = useTranslation();
    useEffect(() => {
        GetBillingService();
    }, []);

    const GetBillingService = async () => {
        let params: any = {};
        params.getBillingInformationType = 9;
        params.referenceId = 0;
        BillingCommand.PostGetBillingInformation(params).then((res: any) => {
            console.info(res);
            setLoading(false);
            setBillingLog(res.data);
        });
    };

    console.info(billingLog);

    function handleCopy(id: any) {
        let copyText = document.getElementById(id)?.innerText;
        if (copyText) {
            navigator.clipboard.writeText(copyText);
            Swal.fire({
                icon: 'success',
                title: t('general.copied'),
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }
    return (
        <Grid className="billing-query-drawer">
            <Grid className="billing-query-drawer-header" container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className="billing-query-drawer-title"
                    size={{
                        md: 11.5,
                        xs: 11.5,
                        lg: 11.5,
                    }}
                >
                    <h1 className="headtxt">
                        {t('general.shippingID')}: {id}
                    </h1>
                </Grid>

                <Grid
                    className="billing-query-drawer-close"
                    size={{
                        md: 0.5,
                        xs: 0.5,
                        lg: 0.5,
                    }}
                >
                    <CloseIcon
                        className="svg_icons billing-query-drawer-close-button"
                        onClick={onClose}
                    />
                </Grid>
            </Grid>
            {!billingLog && (
                <Typography className="billing-query-drawer-not-found" variant="h4" sx={{ m: 5 }}>
                    {t('general.notFound')}{' '}
                </Typography>
            )}
            <Fade in={loading}>
                <LinearProgress className="billing-query-drawer-loading" />
            </Fade>
            {billingLog && (
                <div className="billing-query-drawer-billing-log">
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('billingLog')}
                        paperText={'BillingLog'}
                        open={false}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="billingLog" className="jsonViewDiv">
                            {JSON.stringify(JSON.parse(billingLog), null, 2)}
                        </pre>
                    </SCUICollapsiblePaper>
                </div>
            )}
        </Grid>
    );
};
